<template>
  <div>

    <not-allowed v-if="!AllowedDisplay && datas.access!==false"  :page="page" :module="idmodule" :data="datas"></not-allowed>
    <div v-if="AllowedDisplay">    

        <importFile :page="page" :modal="modal" :form="form" :table="table" v-if="initImport" @close="()=>{initImport=false; callAPI();}"/>

          <!-- Dialog qui permet d'afficher les suivi d'emails-->

          <v-dialog
        v-model="dialogTraked"
        :width="($vuetify.breakpoint.xs) ? '100%' : '50%'">
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    "{{ trackedList.objet }}" à {{ trackedList.to }}
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogTraked = false"><v-icon>mdi-close-thick</v-icon></v-btn>      
                    </v-card-title>
                    <v-card-text>
                        <v-data-table
                        v-if="trackedList.list"
                    :headers="[{text:'Status',value:'status'},{text:'Date',value:'date'}]"
                    :items="trackedList.list"
                    hide-default-footer>
                    </v-data-table>
                    <div v-else class="text-center">
                        En attente de réception
                    </div>

                        <div class="pa-4 ma-4 elevation-2 "  v-html="trackedList.corp"></div>
                    </v-card-text>

            </v-card>
        </v-dialog>

          <!-- FIN Email-->



        <!-- Bouton d'ajout sur la table -->
        <v-row no-gutters justify="center" align="center">
          <v-col class="col-6 text-left pa-0 ma-0">
            <v-btn v-if="add" ref="guideAdd" :data-guide-target="`module:${idmodule}:add`" :data-guide-manual-only="['new', 'edit'].includes(typePage) ? 'true' : null" class="ma-1" @click="addLine">
              <span v-if="!add.icon">{{ add.text }}</span>
              <v-icon v-if="add.icon">{{ add.icon }}</v-icon>
            </v-btn>
            <rights-indicator v-if="add" :checks="tableInspectionChecks(add.table || table, ['insert'])" label="Ajouter une ligne" />
          </v-col>
          <v-col class="col-6 text-left d-flex text-caption pa-0 ma-0">
            <span v-if="!hidepagination && !hidenombrelignes">page {{ axiosParams.params.pagination.page }}/{{ pageLength }} : </span><span v-if="!hidenombrelignes"> {{ totalrows }} ligne(s)</span>
          </v-col>
        </v-row>

        <!-- actions sur choix multiple-->
        <div v-if="selectedItem.length && this.datas" class="text-center">
          <div v-for="(men, index) in datas[0].action" :key="index">
          <v-btn v-if="men.params.head" :ref="`guideHeadAction-${men.id}`" :data-guide-target="`module:${idmodule}:action:${men.id}`" data-guide-manual-only="true" @click="onClickButton(selectedItem, men, $event,true)">
            <v-icon>{{ men.icon }}</v-icon> {{ men.name }}
          </v-btn>
          <rights-indicator v-if="men.params.head" :checks="actionInspectionChecks(men)" :label="men.name" />
          </div>
        </div>

        <div v-if="ifnofiltertext" class="text-center text-h5 blue lighten-5 pa-3 rounded">{{ ifnofiltertext }}</div>

        <!-- debut su tableau -->
        <v-progress-linear v-if="enrichmentLoading" indeterminate height="2" />
        <div v-if="enrichmentError" class="text-caption warning--text px-2">{{ enrichmentError }}</div>
        <v-data-table 
        v-model="selectedItem"
        :hide-default-header="hideheaders"
        :headers="headers" 
        :items="datas" 
        :loading="loading" 
        hide-default-footer 
        :disable-pagination="hidepagination"
        :show-select="axiosParams.params.pagination.showselect"
        @input="selectAll"
        show-expand

        fixed-header
        :height="tableHeight"
        :expanded.sync="expanded"
        :single-expand="true"
        item-key="id"
        :single-select="!axiosParams.params.pagination.singleselect"
        :options="axiosParams.params.pagination" 
        class="istable app-theme-table" click:row=""
        :page="axiosParams.params.pagination.page" 
        @update:options="reloadTable" 
        :footer-props="{
  'items-per-page-options': rowsPerPageItems
}">

          <template v-for="head in headers.filter(column => column.fieldId)" v-slot:[`header.${head.value}`]>
            <span :key="'rights-header-' + head.value">{{ head.text }}<rights-indicator :checks="[{ core: 'showfields', id: head.fieldId }]" :label="head.text" /></span>
          </template>

          <!-- Affichage des sommes -->
          <template slot="body.append">
            <td v-if="axiosParams.params.pagination.showselect" >
            </td> 
            <td class="grey-lighten-3" v-for="head in headers" :key="head.cle">

                <div v-if="head.value == 'action' && somme.length" class="text-center text-no-wrap pa-5">Somme</div>
                <div :class="'text-no-wrap pa-5   text-' + head.align">{{ somme[head.value] }} </div>

                <div v-if="head.value == 'action' && average.length" class="text-center text-no-wrap">Moyenne</div>
                <div :class="'text-no-wrap pa-5 text-' + head.align">{{ average[head.value] }} </div> 

            </td>
          </template>

        <!-- Affichage des action en header pour import ou export -->
          <template v-slot:[`header.action`]="{ item }">
            {{ item }}
            <v-menu offset-y >
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on">mdi-chevron-down</v-icon>
              </template>
              <v-list>

                  <v-list-item @click="exportExcel" >
                  <v-list-item-title><v-icon>mdi-file-excel-outline</v-icon> exporter le tableau</v-list-item-title>
                  <rights-indicator :checks="tableInspectionChecks(table, ['export'])" label="Exporter le tableau" />
                  </v-list-item>
                  <v-list-item @click="initImport = true" >
                  <v-list-item-title><v-icon>mdi-download</v-icon> Importer à partir d'un fichier</v-list-item-title>
                  <rights-indicator :checks="tableInspectionChecks(table, ['insert'])" label="Importer des lignes" />
                  </v-list-item>

              </v-list>
            </v-menu>
          </template>

          <!-- Affichage ligne par ligne -->
  <template v-slot:item="{ item, index, expand, isExpanded }" >

    <tr :data-guide-row-id="item.id" :class="['v-data-table--selected',{'v-data-table__mobile-table-row':$vuetify.breakpoint.xs}]" :style="{ 'background-color': getDefaultRowBackground(item, index) }">
      <td v-if="axiosParams.params.pagination.showselect">
        <v-checkbox v-model="item.selected" class="ma-0" justify="center" align="center"
        @click="toggleSelected(item)"
        red></v-checkbox>

      </td>   
    <td @click="launchExpend(item,head,expand,isExpanded)" v-for="(head,i) in headers" :key="i" 
    :style="getCellStyle(item, index)"
    :class="{'v-data-table__mobile-row':$vuetify.breakpoint.xs}">
      
    <!--on place ce div qui est affihé uniquement si version mobile (affiche le nom de la colonne à gauche du résultat)-->
    <div class="v-data-table__mobile-row__header" v-html="head.text" v-if="$vuetify.breakpoint.xs"></div>

    <div v-if="head.value!='action'"
      @click="showTracked(item)"
      :class="['text-'+head.align,{'v-data-table__mobile-row__cell':$vuetify.breakpoint.xs}]"
      :style="getRowContentStyle(item, index)"
      >
      <VisualRenderer v-if="head.visuel" :item="head.visuel" :line="item" :page="modalKey"
        :action-resolver="visualActionResolver(item, head)" @action="payload => onVisualAction(item, head, expand, isExpanded, payload)" />
      <span v-else v-html="item[head.value]"></span>
    </div>

      <div v-if="head.value=='action' && rowMenuActions(item).length"
      :class="['text-center',{'v-data-table__mobile-row__cell':$vuetify.breakpoint.xs}]">
            <v-menu offset-y v-model="guideRowMenus[item.id]" :close-on-click="!guideRunning">
              <template v-slot:activator="{ on, attrs }">
                <v-icon data-guide-row-menu v-bind="attrs" v-on="on">mdi-chevron-down</v-icon>
              </template>
              <v-list>
                <rights-indicator v-if="guideRowMenus[item.id]" :checks="tableInspectionChecks(table, ['watch', 'update', 'delete'], item)" label="Droits sur cette ligne" />
                <template v-for="(men, index) in rowMenuActions(item)" >
                  <v-list-item :ref="`guideAction-${item.id}-${men.id}`" :data-guide-manual-only="men.typelink === 'link' ? null : 'true'" :key="index" class="chat-share-host" @click="onClickButton(item, men, $event)" >
                  <v-list-item-title><v-icon class="mr-4">{{ men.icon }}</v-icon>{{ men.name }}</v-list-item-title>
                  <rights-indicator :checks="actionInspectionChecks(men)" :label="men.name" />
                  <ChatShareMenu :modal-key="modalKey" :reference="actionReference(item, men)" label="Partager cette action dans le chat" />
                </v-list-item>
                </template>

              </v-list>
            </v-menu>      
      </div>
      </td>

    </tr> 
 
  </template>

          <!-- fin ligne par ligne -->


          <!-- Encart d'expension juste en dessous de la ligne ca pourrait servir-->
      <template v-slot:expanded-item="{  }">
        <!-- <td :colspan="headers.length">Expanded Content</td> -->
        <td :colspan="headers.length">
            <!-- contenu sur toute la largeur -->

             <v-card class="rounded-lg elevation-3" style="border:1px solid #7986CB;">
              <v-card-text class="indigo lighten-5"  >
                <main-component 
                v-if="actionOnLine.page" 
                :key="JSON.stringify(actionOnLine.params)"
                :customparams="actionOnLine.params" 
                :customquerys="actionOnLine.querys"  
                :page="actionOnLine.page" 
                :modal="modal"
                :independant="true"
                :typeform="actionOnLine.typeform"
                hook="fromtable"></main-component>

                <div v-if="actionOnLine.fields.length">
                <v-form
                :ref="'form-'+idExtended"
                v-model="modelForm"
                lazy-validation
                >
                  <v-btn icon class="primary" @click="saveUpdateFields"><v-icon>mdi-content-save</v-icon></v-btn>
                  <fromBDD 
                  v-for="field,i in actionOnLine.fields"
                  :key="'f'+i+idExtended"
                  :item="{fromBDD:field.id,defaultprops:{show:true}}"
                  :valField="fieldsUpdated[field.id]"
                  :modalKey="modalKey"
                  :change="(item,value,sel) => { changeOnClickField(item,value,sel) }"
                  :keyup="(item,value,ifenter) => { changeOnClickField(item,value,false,ifenter) }"
                  @keyup.enter="saveUpdateFields"
                  :modal="modal"
                  :hook="hook"
                  :mod="mod"
                  @loaded="(Zfield) => {$store.dispatch('pushForm', { page:keyForUpdate, value:field.value, champ:Zfield.value }); $set(fieldsUpdated, field.id, field.value) }"
                  /> 
                  </v-form>
                </div>

              </v-card-text>

             </v-card>

          </td>
      </template>

          <!-- Affichage du footer : pagination et nbr par page-->
          <template slot="footer">
            <v-row justify="center" no-gutters>

              <v-col lg="4" class="text-center d-flex align-center justify-center text-caption" v-if="!hidepagination">
                <v-pagination v-model="axiosParams.params.pagination.page" :length="pageLength" :total-visible="7"
                  @input="onPageChange"></v-pagination>


              </v-col>
              <v-col class="text-center d-flex align-center justify-center text-caption">
                <span v-if="!hidepagination">page {{ axiosParams.params.pagination.page }}/{{ pageLength }} : </span><span v-if="!hidenombrelignes"> {{ totalrows }} ligne(s)</span>
              </v-col>
              <v-col lg="1" class="text-center d-flex align-center justify-center text-caption" v-if="!hidepagination">
                <v-select class="text-center" v-model="axiosParams.params.pagination.itemsPerPage"
                  :items="rowsPerPageItems" :full-width="false" v-on:change="onPerPageChange"></v-select>
              </v-col>
              <v-col lg="2" class="text-center d-flex align-center justify-start text-caption" v-if="!hidepagination">
                lignes/page
              </v-col>
            </v-row>

          </template>
          <!-- fin footer -->


          <!-- quand il n'y a aucune ligne -->
          <template v-slot:no-data>
            <v-alert :value="true">
              Aucune information disponible sur votre recherche
            </v-alert>
          </template>
        </v-data-table>
      </div>
  </div>
</template>

<script>
import trackemail from './trackedEmail'
import { client } from '../mixins';
//permet de récupérer l'enregistrement sur une page extension, afin de fermer l'extension sous une ligne
import { EventBus } from '../../../services/EventBus';
import fromBDD from '../../fields/fromBDD.vue'
import ChatShareMenu from '@/components/chat/ChatShareMenu.vue'
import guideAdapter from './guideAdapter'
import moduleEnrichmentsMixin from '../shared/moduleEnrichmentsMixin'
import { contextualActionArguments, contextualActionAllowed, visualKeyCount } from './actionTargets'

export default {
// form étant le "ref='form'" de la page, ca sert à valider le formulaire d'ici

  mixins : [trackemail,client,guideAdapter,moduleEnrichmentsMixin],

  components : {
                ChatShareMenu,
                importFile   : () => import('./importFile.vue'),
                VisualRenderer: () => import('../../engine/outils/constructVisuel/display/Renderer.vue'),
                fromBDD,
        },

  data: function () {
    return {

      expanded: [],
      // permet de ne pas effectuer de reloadTable lors de la première initiation (voir fonction reloadTable)
      init: false,
      //
      initImport : false,
      //serv pour l'imortation de fichier
      table:'',
      headers: [],
      datas: [],
      // liste les lignes sélectionnés :
      selectedItem : [],
      // permet de stopper l'enregistrement dans un form si aucune ligne est présente dans ce tableau
      stopWhenNoLine : false,
      // permet de voir si on affiche le bouton ajout ou psa :
      add: {},
      // permet d'affiche le chargement sur le tableau
      loading: true,
      totalrows: 0,
      pageLength: 1,
      // affiche le total par colonne si il y a 
      somme: [],
      // affiche la moyenne par colonne si il y a
      average: [],
      // voir la fonction onPerPageChange
      perperChange: false,
      // recupère les modules de recherche lié à ce tableau
      searchmodule: [],
      //permet de récupérer l'action de click sur colonne ou ligne
      onclickLine : [],
      //permet d'envoyer les infos de la page qui va etre ouverte par l'extension de la ligne.
      actionOnLine : {type:'',fields:[],page:'',params:{},querys:{},typeform:''}, 
      //permet d'avoir l'id de l'extension en cours, pour le refermer une fois enregistré
      idExtended : false,
      // permet de stocker les clé et valeur des champs qui seront updatés sur le click d'une ligne
      fieldsUpdated : {},
      // permet de définir si ce module est intégré dans une page form (nouvelle:newform ou en mode édition:editform), ou une page classique : page
      typePage : (!this.$store.getters['listForm'](this.modalKey)) ? 'page' : this.$store.getters['listForm'](this.modalKey).typeform ,

      rowsPerPageItems: [5, 10, 20, 50, 100],

      // va stocker l'url et les params de la page, essentiellement pour enregistrer le formulaire

      axiosParams: {type: 'post', url: 'displaymodule', params: { id: this.idmodule, pagination: {page:1}, querys: {}, params: {} } },

      //permet d'afficher un texte personnalisé si aucun filtre n'est appliqué sur la table
      ifnofiltertext : '',

      hidepagination : false,
      hidenombrelignes : false,
      hideheaders : false,
      AllowedDisplay: true,
      // pour fixer le header avec un height auto :
      rowHeight: 55, // Hauteur approximative d'une ligne de la table
      tableHeight: 'auto', // Valeur initiale
      //permet de savoir si l'ouverture d'une modal se fait à partir de ce module, alors on rafraichi la table
      fromThisMod : false,
      //modele de formulaire sur champ à la volé
      modelForm : true,
      keyForUpdate : 'IUPD_'+this.modalKey,
    }
  },

  updated() {
        // Reajuster les divs à chaque mise à jour du DOM
        this.getHeightTable();

    },

  computed: {

    callBackOnCloseModal() {
      return this.$store.getters.modalShowParams({ type: 'current', val: this.modalKey })
    },


    //reloadTables est alimenté par un retour de ventilation, activé par vuex (voir sur cette page : callBackOnCloseModal)
    isReload() {
      return this.$store.getters.reloadTables
    },

  },
  watch: {

    '$route.query'(val, oldVal) {
      const keys = new Set([...Object.keys(val || {}), ...Object.keys(oldVal || {})]);
      const changed = [...keys].some(key => this.searchmodule.some(id => key.startsWith(id + '_'))
        && JSON.stringify(val[key]) !== JSON.stringify((oldVal || {})[key]));
      if (changed) {
        this.axiosParams.params.querys = {...val};
        this.axiosParams.params.pagination.page = 1;
        this.callAPI();
      }
    },


    isReload(val) {
      
      if (val.includes(this.idmodule)) {
        
        this.axiosParams.params.params = this.$store.getters.specificPage(this.modalKey).params
        this.callAPI();
        this.$store.dispatch('removeReloadTables', this.idmodule);
      }
    },

    callBackOnCloseModal: {
      // permet de rafraichir quand la modal de modif du module de la page se ferme
      handler(val) {

        if (val.show === false && this.fromThisMod) {
        this.callAPI();
        this.fromThisMod = false
        }
      }, deep: true


    },



  },
  methods: {

    handleCloseFromTable() {
      if (this.expanded[0] && this.idExtended == this.expanded[0].id) {
        this.callAPI()
        this.expanded = []
        this.idExtended = false
      }
    },

    getDefaultRowBackground(item, index) {
      const rawColor = item && typeof item['rowBackColor'] === 'string' ? item['rowBackColor'].trim() : item && item['rowBackColor'];
      if (rawColor) {
        return item['rowBackColor'];
      }
      if (typeof index === 'number') {
        return index % 2 === 0
          ? 'var(--app-table, #FFFFFF)'
          : 'var(--app-table-alternate, #F8F8F8)';
      }
      return 'var(--app-table, #FFFFFF)';
    },

    getRowContentStyle(item, index) {
      const styles = { 'background-color': this.getDefaultRowBackground(item, index) };
      const rawColor = item && typeof item['rowColor'] === 'string' ? item['rowColor'].trim() : item && item['rowColor'];
      if (rawColor) {
        styles.color = item['rowColor'];
      }
      return styles;
    },

    getCellStyle(item, index) {
      const rawColor = item && typeof item['cellBackColor'] === 'string' ? item['cellBackColor'].trim() : item && item['cellBackColor'];
      if (rawColor) {
        return { 'background-color': item['cellBackColor'] };
      }
      return { 'background-color': this.getDefaultRowBackground(item, index) };
    },

    
    changeOnClickField(item,value,selectedKey,ifEnter) {

        var realValue = value;
            if((item.format=='autocomplete' || item.format=='select')) {
                realValue = [];
                
                if(item.defaultprops.multiple) {
                    for(var selected in value) {
                        if(typeof value[selected] == 'object') { realValue.push(value[selected][selectedKey]) } else { realValue.push(value[selected]); }
                    }
                } else {

                realValue = (typeof value =='object' && value!=null) ? value[selectedKey] : value;  
                  
                }

            } else {
              //si on est sur un onkeyup et qu'il clique sur "entrer"
              if(ifEnter==true) {
                this.saveUpdateFields();
              }
            }
            
      this.$set(this.fieldsUpdated, item.cle, realValue)
      this.$set(this.fieldsUpdated, item.id, realValue)
      this.$store.dispatch('pushForm', { page:this.keyForUpdate, value:realValue, champ:item.cle })

    },

    saveUpdateFields() {
        if(this.idExtended) {

          this.$store.dispatch('textOverlay','enregistrement en cours');
          this.validateForm({form:this.$refs['form-'+this.idExtended],page:this.page,modalKey:this.keyForUpdate,validate:0,hook:this.hook,
              callback:()=> {                       
                      this.expanded = [];
                      this.idExtended = false;
                      this.callAPI();
            }})

        } else {
              this.expanded = [];
              this.idExtended = false;          
        }
    },

    rowMenuActions(item) {
      return (item.action || []).filter(action => !action.params.head && action.params.showInRowMenu !== false)
    },
    visualActionContext(item, itemData) {
      return { line: item, itemData, page: this.modalKey, replaceBy: this.replaceBy }
    },
    visualTargetRules(head, key) {
      return this.onclickLine.filter(rule => rule.field === head.value && rule.elementKey === key)
    },
    visualActionResolver(item, head) {
      return ({ key, itemData }) => {
        const rules = this.visualTargetRules(head, key)
        const candidates = item.visualActions || []
        return { matched: rules.length > 0, enabled: visualKeyCount(head.visuel, key) === 1 && rules.some(rule => rule.type === 'field' || candidates.some(action => String(action.id) === String(rule.action) && contextualActionAllowed(action.params.conditions || [], this.visualActionContext(item, itemData)))) }
      }
    },
    onVisualAction(item, head, expand, isExpanded, payload) {
      const rules = this.visualTargetRules(head, payload.key)
      if (!this.visualActionResolver(item, head)(payload).enabled) return
      this.launchExpend(item, head, expand, isExpanded, rules, payload.itemData)
    },
    launchExpend(item,head,expand,isExpanded,elementRules = null,itemData = null) {
      console.log(isExpanded,this.idExtended ,item.id);
      //si il clique sur la colonne des lis te de bouton
      if(head.value=='action') return;
      //si l'extension n'est pas encore ouverte

      if(elementRules || (!isExpanded && this.idExtended != item.id)) {
      //remise à zero des paraètres de page
      if (!elementRules || elementRules.some(rule => rule.type === 'field' || rule.openmode === 'underline')) {
        this.actionOnLine = {type:'',fields:[],page:'',params:{},querys:{},typeform:''}
        this.fieldsUpdated = {};
      }

      const columnRules = this.onclickLine.filter(act => !act.elementKey)
      let hasExactMatch = columnRules.some(act => act.field === head.value)
        //pour chaque action qui est relié à une colonne
        ;(elementRules || columnRules).forEach((act) => {
          //on check le nom de colonne qui a été cliqué avec la colonne enregistré dans l'action
          if (elementRules || act.field === head.value || (!hasExactMatch && act.field === 'all')) {
            this.actionOnLine.type = act.type

            //si on clique pour modifier un ou plusieurs champs selon le paramètre choisi
            if(act.type=='field') {

              // on initialise le form pour que les conditions soient prises en compte
              this.$store.dispatch('initForm', { page:this.keyForUpdate,valid:true,typeform:'edit',
              url:'/interface/'+this.table+'/'+item.id+'/edit'});
              act.listFieldsUpdate.forEach((f) => {
                this.actionOnLine.fields.push({id:f,value:item['_forupd_'+f]})
              })
              this.idExtended = item.id;
              expand(elementRules ? true : !isExpanded)
              return;
            }
            //si action
            // on regarde si l'action est bien présente sur la ligne cliqué
            let action = (elementRules ? item.visualActions || [] : item.action).find(e => String(e.id) === String(act.action))
            if(action) {
              const context = this.visualActionContext(item, itemData)
              if (elementRules && !contextualActionAllowed(action.params.conditions || [], context)) return
              //si c'est un appel api ou que le param d'ouverture se fait selon le param de l'action
              if(action.typelink !== 'link' || act.openmode=='origin') {
                    if (elementRules) this.dispatchVisualAction(item, action, context)
                    else this.onClickButton(item,action)
              } else {
                //si c'est un type link (donc page) et que l'ouverture est en mode sous la ligne (underline)
                expand(elementRules ? true : !isExpanded)
                const resolved = contextualActionArguments(action, context)
                this.actionOnLine.params = resolved.params
                this.actionOnLine.querys = resolved.query

              let type = this.newurl({name:action.page_name,replace:{},returnElement:'all'});
              this.actionOnLine.typeform =  type.props.typeform
              this.actionOnLine.page = type.props.page
              this.idExtended = item.id

              } //fin type = link

            } //fin si action

          } //fin si action trouvé 


        })
      } else {
        //on ferme l'extension
        this.idExtended = false
        expand(!isExpanded)
      }
      
    },

    async dispatchVisualAction(item, action, context) {
      const resolved = contextualActionArguments(action, context)
      if (action.typelink === 'link') {
        if (action.target === 'modal') this.fromThisMod = true
        this.goTo({ modalKey: this.modalKey, name: action.page_name, type: action.target,
          replace: resolved.params, query: resolved.query, paramDialog: action.paramdialog, setactivtab: resolved.setactivtab })
        return
      }
      if (action.typelink === 'href') {
        if (resolved.url && resolved.url !== 'null') window.open(String(resolved.url), '_blank')
        else this.$toast.error('Lien non inséré')
        return
      }
      if (action.typelink !== 'api') return
      if (action.params.ifconfirm && !window.confirm(action.params.ifconfirm)) return
      const line = { ...item }
      delete line.action
      delete line.visualActions
      this.$store.dispatch('textOverlay', 'Action en cours')
      this.$store.dispatch('getoverlay', true)
      try {
        const url = String(resolved.url || '')
        const hashIndex = url.indexOf('#')
        const baseUrl = hashIndex < 0 ? url : url.slice(0, hashIndex)
        const suffix = hashIndex < 0 ? '' : url.slice(hashIndex)
        const queryString = new URLSearchParams(Object.entries(resolved.query).map(([key, value]) => [key, value && typeof value === 'object' ? JSON.stringify(value) : String(value ?? '')])).toString()
        const response = await this.API({ type: action.params.apilink.type, url: baseUrl + (queryString ? (baseUrl.includes('?') ? '&' : '?') + queryString : '') + suffix,
          params: { ...resolved.params, action: action.id, line, selected: false } })
        const data = response.data
        if (data.ventilation) {
          const scenario = data.ventilation.before || data.ventilation.after || [data]
          await this.checkScenario({ ventilation: scenario, page: this.page, modalKey: this.modalKey, row: 0 })
        }
        if (data.success) {
          if (data.message) this.$toast.success(data.message)
          this.selectedItem = []
          this.callAPI()
        } else if (data.message) this.$toast.error(data.message)
      } catch (error) {
        this.$toast.error('L’action n’a pas pu être exécutée.')
      } finally {
        this.$store.dispatch('getoverlay', false)
      }
    },

    getHeightTable() {

        if (!this.datas.length) {
          return;
        }
      this.tableHeight = 'auto';
      
    },

    exportExcel() {
      this.axiosParams.params.export='all';
      this.axiosParams.apidefault = {responseType:'blob',headers:{'Accept':'application/vnd.ms-excel'}}
      this.API(this.axiosParams).then((resp) => {
        const url = window.URL.createObjectURL(new Blob([resp.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'excel.xlsx');
                        document.body.appendChild(link);
                        link.click();   
      delete this.axiosParams.params.export;
      this.axiosParams.apidefault = {responseType:'json',headers:{'Accept':'application/json'}}     
      })
    },

    toggleSelected(item) {

      if(!item.selected) this.selectedItem = this.selectedItem.filter(el => el.id !=item.id)
      if(item.selected) this.selectedItem.push(item)
    },

    selectAll(all) {
      this.datas.forEach((item)=> {
          const foundIndex = all.findIndex(i => i.id === item.id);
          item.selected = (foundIndex>=0)? true : false;
        }) 
    },

    // permet de construire l'array du header
    parseHeader: function (header) {
      var head = []
      header.forEach((val) => {
        var text = (val.affichage == '_act') ? "" : val.affichage;
        var isAct = (val.affichage == '_act') ? true : false;
        var setHead = {
          text: text,
          value: val.cle,
          align: val.display.align,
          sortable: val.display.issortable,
          isAct:isAct,
          width: val.width || undefined,
          visuel: val.visuel || null,
          fieldId: val.field_id || null,
        }

        head.push(setHead);
      });

      // permet d'afficher l'expansion en dessousde chaque champ (c'est actif par défaut, mais il n'y a rien dans le contenu pour l'instant)
      head.push({ text: '', value: 'data-table-expand' })

      return head;
    },

    callAPI() {
      this.cancelModuleEnrichments();
      const generation = this._tableLoadGeneration = (this._tableLoadGeneration || 0) + 1;
      this.loading = true;
      return this.API(this.axiosParams).then((resp) => {
        if (generation !== this._tableLoadGeneration) return;
        this.manageDatas(resp.data)
      }).finally(() => { if (generation === this._tableLoadGeneration) this.loading = false; })

    },

    manageDatas(data) {
      const datas = data
        if (!data.success) {
          this.AllowedDisplay = false;
          this.datas = data
          return false;
        }

        this.headers = this.parseHeader(datas.headertab);
        this.datas = datas.datas
        // on applique si des lignes sont selectionnés ou pas :
        this.datas.forEach((item)=> {
          const foundIndex = this.selectedItem.findIndex(i => i.id === item.id);
          if(foundIndex>=0) item.selected = true
        }) 
        this.enrichModuleRows(this.datas, datas.enrichmentsMetier || [], {
          token: datas.enrichmentToken, params: this.axiosParams.params.params, querys: this.axiosParams.params.querys,
        })
        this.stopWhenNoLine = true
        
        this.pageLength = datas.totalPage
        this.totalrows = datas.totalrows
        this.loading = false;
        this.add = datas.add
        this.somme = datas.somme;
        this.onclickLine = datas.onclickline;
        this.average = datas.average;
        this.searchmodule = datas.search;
        this.hidepagination = datas.pagination.hidepagination
        this.hidenombrelignes = datas.pagination.hidenombrelignes
        this.hideheaders = datas.pagination.hideheaders
        this.table = datas.table
        this.ifnofiltertext = datas.ifnofiltertext
        this.getHeightTable()
              this.axiosParams.params.page = datas.pagination.page;
              this.axiosParams.params.pagination = datas.pagination;
              this.axiosParams.params.pagination.itemsPerPage = datas.pagination.itemsPerPage;                     

        setTimeout(() => {
          this.init = true;
        }, 500)      
    },

    onPageChange: function (nb) {
      // variable page obligatoire afin que laravel puisse change de page dans le controller. serv uniquement à ca, il faut le post ou le get page=x
      this.axiosParams.params.page = nb
      this.callAPI();
    },

    onPerPageChange: function () {
      // on remet la page à 1 sinon selon le nombre de lignes, si on fait un affichage à 100 avec la page 5, on verra rien 
      this.perperChange = true
      // on ne met pas le this.getFromAPI() ici car en faisant un change, le v-model est = dataSend.pagination.itemsPerPage
      //donc ca fait un reload automatique par le biais du @update:options="reloadTable" de v-data-table
    },

    reloadTable: function (options) {

      //reloadTable se lance automatiquement lors d'un changement dans l'option.. (visible dans le DOM de v-data-table)

      // this.init permet de ne pas charger la table lors du premier load car :
      // lors de l'ouverture du component, les options de pagniation de v-data-table sont à {}.
      //le fait est que v-data-table attribue par défaut des paramétrages d'options basiques mais qui ne sont pas les notre dans le module.
      // donc en ouvrant le composant ca fait un reload direct ce qui entraine un this.getFromAPI() avec les mauvaises infos.

      if (this.init) {

        this.axiosParams.params.pagination = {...this.axiosParams.params.pagination, ...options}
        
        if (this.perperChange) {

          this.axiosParams.params.pagination.page = 1
          this.axiosParams.params.page = 1
          this.perperChange = false;
        }

        this.callAPI();
      }
    },

    onClickButton: function (item, men, event,multipleLines) {
      if(men.target=='modal') this.fromThisMod = true;
      let sItems = item;
      if(multipleLines) {
        sItems = JSON.parse(JSON.stringify(this.selectedItem))
        sItems.forEach((it) => {
          delete it.action;
        })
      }

      this.clickActions({args:sItems,action:men,idmodule:this.idmodule,page:this.page,modalKey:this.modalKey,multipleLines:multipleLines,
      success:(datas) => {
        if(datas.message) this.$toast.success(datas.message);
        this.selectedItem = []
          if(men.typelink == 'api') this.callAPI();
      }    
      })

    },

    actionReference(row, action) {
      return { type: 'action', module_id: this.idmodule, action_id: action.id, page_id: this.page, row_id: row.id,
        context: { row, params: this.axiosParams.params.params || {}, querys: this.axiosParams.params.querys || {} } }
    },

    addLine() {

      let getParentTable = this.$store.getters.specificPage(this.modalKey).table

          // on créer les variables provenants du module partie ajout :
          let variables = {};

      // si la page d'édition de la table ce module est créé
        if(this.add.href) {
          variables['id'] = 'new';

        // si ce module est intégré dans une page de type form et que ce form on enregistre avant d'ajouter une ligne dans la table de ce module
        if (this.typePage=='new' || this.typePage=='edit') {
          
          
          
          // on enregistre le formulaire avant l'envoi sur la page d'édition de ce module' :
          this.validateForm({form:this.form,page:this.page,modalKey:this.modalKey,validate:1,
            ifNotValid:()=>{
              this.$toast.warning('Vérifiez certains champs non complétés',{position: "top-center",timeout: 3000});
            },
            callback:(datas)=> {
              // on transforme les variables ici car lors du précédent enreg, ca a pu moidifier les params
              this.add.variables.forEach((v) => {
                variables[v.key] = this.replaceBy({ text: v.value, page: this.modalKey });
              })

              variables['idparent'] = datas.args.id;
              this.goTo({ modalKey:this.modalKey, name: this.add.href, typeform:'new', type: this.add.type, replace: variables, paramDialog: this.add.paramdialog })
              this.fromThisMod = true
            }
          }) 

        } else {
          this.add.variables.forEach((v) => {
                variables[v.key] = this.replaceBy({ text: v.value, page: this.modalKey, datas:this.customparams });
              })
          // si ce module est dans une page, on envoi la page d'édition de la table de ce module
          this.goTo({ modalKey:this.modalKey, name: this.add.href, typeform:'new', type: this.add.type, replace: variables, paramDialog: this.add.paramdialog })          
          this.fromThisMod = true
        }
        
      
      } else {
        
        // si la page d'édition de la table ce module n'est pas créé
        if (confirm("la page d'édition de la table " + this.add.table + " n'est pas créée, voulez-vous la créer maintenant ? ")) {

          variables['id'] = 'new';
          // si ce module est intégré dans une page de type form et que ce form on enregistre avant d'ajouter une ligne dans la table de ce module
          if (this.typePage=='new' || this.typePage=='edit') {
            
            // on enregistre le formulaire avant l'envoi sur la page d'édition de ce module' :
            // on met validate 1 pour signifier que c'est un enregistrement classique
            this.validateForm({form:this.form,page:this.page,modalKey:this.modalKey,validate:1,
              ifNotValid:()=>{
                this.$toast.warning('Vérifiez certains champs non complétés',{position: "top-center",timeout: 3000});
              },
              callback:(datas)=> {
                        // après l'enregistrement on créer la nouvelle page form:
                        this.createNewPage({ name: 'edit' + this.add.table, type: 'form', table: this.add.table,parentform:getParentTable,url:'/interface/'+getParentTable+'/:idparent/'+this.add.table+'/:id/edit' ,
                                callback:()=> {
                                  variables['idparent'] = datas.args.id;
                                this.goTo({ modalKey: this.modalKey, name: 'new'+this.add.table, typeform:'new', type: this.add.type, replace: variables, paramDialog: this.add.paramdialog})
                                this.fromThisMod = true
                                }
                            }); 
              }
            }) 

          } else {
            // si ce module est dans une page, on envoi la page d'édition de la table de ce module
            this.createNewPage({ name: 'edit' + this.add.table, type: 'form', table: this.add.table,parentform:getParentTable,url:'/interface/'+this.add.table+'/:id/edit' ,
                                callback:()=> {
                                this.goTo({ modalKey:this.modalKey, name: 'new'+this.add.table, typeform:'new', type: this.add.type, replace: variables, paramDialog: this.add.paramdialog})
                                this.fromThisMod = true
                                }
                            });         
          }

        }

      }

    }



  },
  // created s'effectue avant le mounted
  created() {
    //reçu par globalFunctions lors de la fin de l'enregistrement
    EventBus.$on('closeFromTable', this.handleCloseFromTable)
  },

  mounted() {
    // on prend les filtres de recherches pour l'utiliser dans le watch
    this.searchData = this.$store.getters['getSearchValues'];
    // permet de récupérer les id qui proviennent de l'url

    this.axiosParams.params.params = this.$store.getters.specificPage(this.modalKey).params

    if(this.customparams) this.axiosParams.params.params = this.customparams

    this.axiosParams.params.querys = JSON.parse(JSON.stringify(this.$route.query || {}));
    
    let getdatas = this.$store.getters.getModuleDatas({page:this.modalKey,id:this.idmodule});
    if(getdatas) {
        this.manageDatas(getdatas.datas)
        this.$store.dispatch('removeModuleDatas',{page:this.modalKey,id:this.idmodule})
    } else {
      this.callAPI(); 
    } 
    window.addEventListener('resize', this.getHeightTable);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.getHeightTable)
    EventBus.$off('closeFromTable', this.handleCloseFromTable)
  }

}

</script>

<style scoped>
.app-theme-table {
  background-color: var(--app-table, #fff) !important;
}

.app-theme-table.v-data-table.v-data-table--fixed-header ::v-deep thead th {
  background-color: var(--app-table-header, #f1f3f8) !important;
}
</style>
